import { createApiAction } from 'src/api';

export const ADD_WEBSITE_START = 'account/add_website_start';
export const ADD_WEBSITE_SUCCESS = 'account/add_website_success';
export const ADD_WEBSITE_FAILURE = 'account/add_website_failure';

export const UPDATE_WEBSITE_START = 'account/update_website_start';
export const UPDATE_WEBSITE_SUCCESS = 'account/update_website_success';
export const UPDATE_WEBSITE_FAILURE = 'account/update_website_failure';

export const DELETE_WEBSITE_START = 'account/delete_website_start';
export const DELETE_WEBSITE_SUCCESS = 'account/delete_website_success';
export const DELETE_WEBSITE_FAILURE = 'account/delete_website_failure';

export const addAccountWebsite = ({ accountId, url }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/websites/`,
      method: 'POST',
      body: {
        website_url: url,
      },
    },
    [ADD_WEBSITE_START, ADD_WEBSITE_SUCCESS, ADD_WEBSITE_FAILURE]
  );

export const updateAccountWebsite = ({ accountId, websiteId, url }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/websites/${websiteId}/`,
      method: 'PUT',
      body: {
        website_url: url,
      },
    },
    [UPDATE_WEBSITE_START, UPDATE_WEBSITE_SUCCESS, UPDATE_WEBSITE_FAILURE]
  );

export const deleteAccountWebsite = ({ accountId, websiteId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/websites/${websiteId}/`,
      method: 'DELETE',
    },
    [DELETE_WEBSITE_START, DELETE_WEBSITE_SUCCESS, DELETE_WEBSITE_FAILURE]
  );
};
